import { makeAutoObservable } from 'mobx';
import type { UserType } from '../types/user.type';

export class UserStore {
  private _isAuth = false;
  private _user: UserType | undefined = undefined;

  constructor() {
    makeAutoObservable(this, {}, { deep: true });
  }

  public get isAuth(): boolean {
    return this._isAuth;
  }

  public setIsAuth(auth: boolean) {
    this._isAuth = auth;
  }

  public get user(): UserType | undefined {
    return this._user;
  }

  public setUser(user: UserType): UserType {
    this._user = user;
    return this._user;
  }

  public deleteUser(): void {
    this._user = undefined;
  }

  public updateUser(updates: Partial<UserType>): UserType | undefined {
    if (this._user) {
      this._user = { ...this._user, ...updates };
    }
    return this._user;
  }
}

export const userStore = new UserStore();
